
export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Browse & Select',
      description: 'Explore our curated directory of professional private chefs. Filter by location, cuisine type, and availability to find your perfect match.',
      icon: 'ri-search-2-line'
    },
    {
      number: '02',
      title: 'Book & Customize',
      description: 'Contact your chosen chef directly to discuss your event details, dietary requirements, and menu preferences for a personalized experience.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '03',
      title: 'Enjoy & Relax',
      description: 'Sit back and enjoy an exceptional culinary experience as your chef prepares and serves a memorable meal in your chosen location.',
      icon: 'ri-restaurant-2-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            How It <span className="text-emerald-600">Works</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Getting started with SERVDFRESH is simple. Follow these three easy steps 
            to book your perfect private chef experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-emerald-200 transform -translate-y-1/2 z-0">
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-emerald-400"></i>
                    </div>
                  </div>
                </div>
              )}
              
              <div className="relative z-10 text-center">
                <div className="w-20 h-20 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                
                <div className="mb-4">
                  <span className="text-6xl font-bold text-emerald-100">{step.number}</span>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
